import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiCalendar, FiCheckCircle, FiArrowRight, FiYoutube } = FiIcons;

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-black-pure pt-32 pb-20 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-mesh-dark opacity-40 pointer-events-none"></div>
      
      <div className="container mx-auto px-6 relative z-10 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center space-x-2 bg-green-500/10 border border-green-500/20 px-4 py-2 rounded-full mb-8">
            <SafeIcon icon={FiCheckCircle} className="text-green-500" />
            <span className="text-green-500 font-black text-[10px] uppercase tracking-widest">Registrazione Completata</span>
          </div>
          <h1 className="text-4xl md:text-7xl font-black text-white uppercase tracking-tighter leading-none mb-6">
            COMPLIMENTI PER ESSERTI <span className="text-orange-500 italic">ISCRITTO</span> MA...
          </h1>
          <p className="text-xl md:text-2xl text-slate-300 font-bold uppercase tracking-tight max-w-2xl mx-auto">
            SE NON SEGUI QUESTI STEP <span className="text-red-500">NON POTRAI PARTECIPARE</span> AL WEBINAR.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-8">
          {/* Step 1 */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="glass-card-dark p-8 md:p-12 rounded-[2.5rem] border-l-4 border-l-orange-500 flex flex-col md:flex-row items-center gap-8"
          >
            <div className="w-20 h-20 bg-orange-600 rounded-3xl flex items-center justify-center shrink-0 shadow-[0_0_30px_rgba(234,88,12,0.4)]">
              <SafeIcon icon={FiSend} className="text-white text-4xl" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-black text-white uppercase mb-2">Step 1: Iscriviti al gruppo Telegram</h3>
              <p className="text-slate-400 font-medium mb-6">
                All'interno del gruppo infatti riceverai il link per poter partecipare alla zoom e tanti altri aggiornamenti.
              </p>
              <a 
                href="https://t.me/+SioJ7hO-UScxZTBk" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-[#229ED9] hover:bg-[#1e8dbf] text-white px-8 py-4 rounded-2xl font-black transition-all transform hover:scale-105"
              >
                <span>ENTRA NEL GRUPPO ORA</span>
                <SafeIcon icon={FiArrowRight} />
              </a>
            </div>
          </motion.div>

          {/* Step 2 */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
            className="glass-card-dark p-8 md:p-12 rounded-[2.5rem] border-l-4 border-l-orange-500 flex flex-col md:flex-row items-center gap-8"
          >
            <div className="w-20 h-20 bg-slate-800 rounded-3xl flex items-center justify-center shrink-0">
              <SafeIcon icon={FiCalendar} className="text-orange-500 text-4xl" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-black text-white uppercase mb-2">Step 2: SALVATI IN AGENDA L'APPUNTAMENTO</h3>
              <p className="text-slate-400 font-medium mb-6">
                Segnati già in agenda la data dell'evento per non rischiare di dimenticartene:
              </p>
              <div className="inline-block bg-white/5 border border-white/10 px-6 py-4 rounded-2xl text-orange-400 font-black text-xl italic uppercase">
                📅 Venerdì 30 Gennaio ore 21:00
              </div>
            </div>
          </motion.div>

          {/* Step 3 */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="glass-card-dark p-8 md:p-12 rounded-[2.5rem] border-l-4 border-l-red-600"
          >
            <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
              <div className="w-20 h-20 bg-red-600/20 rounded-3xl flex items-center justify-center shrink-0">
                <SafeIcon icon={FiYoutube} className="text-red-500 text-4xl" />
              </div>
              <div className="text-center md:text-left">
                <h3 className="text-2xl font-black text-white uppercase mb-2">Step 3: GUARDATI L'INTERVISTA SU ANDREA</h3>
                <p className="text-slate-400 font-medium">
                  Scopri la storia e la visione dietro il percorso di Andrea Zuccarini in questa intervista esclusiva a Dubai.
                </p>
              </div>
            </div>
            <div className="relative w-full overflow-hidden rounded-3xl border border-white/10 shadow-2xl bg-black aspect-video">
              <iframe 
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/QkEDgU9lkiM" 
                title="Intervista ad Andrea Zuccarini a DUBAI" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen
              ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;